<template>
  <div
    v-if="n > 0"
    class="bg-blue-700 p-4 text-white rounded-lg text-center tourleader-intro tourleader-questions !my-2"
  >
    <div
      class="font-bold text-xl mb-3"
      data-i18n="tourleader.questions.title"
    >
      {{ $t('tourleader.questions.title', n) }}
    </div>
    <ul>
      <li
        v-for="(question, idx) in list"
        :key="`q-${idx}`"
      >
        <div class="block font-bold text-sm">
          {{ question?.question }}
        </div>
        <span class="font-secondary text-sm font-normal">
          {{ question?.answer }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    list () {
      return (this.questions || [])
    },

    n () {
      return this.list.length
    },
  },
})
</script>

<style lang="scss">
.tourleader-questions {
  h4 {
    &:after {
      content: "\a0";
      display: block;
      width: 3rem;
      height: 1px;
      background: theme('colors.white');
      margin: 2rem auto;
    }
  }
  li {
    & + li {
      margin-top: 1rem;
    }
  }
}
</style>
